import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setVehicleMileageLoaded } from '../store/tripInformation.actions'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setCalculateVehicleMileageLoaded() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const tripInformation = pcrDoc.patient?.tripInformation
      if (tripInformation && Object.keys(tripInformation).length !== 0) {
        if (tripInformation.vehicleMileageRef !== '' && tripInformation.vehicleMileageRec !== '') {
          const loaded = parseFloat(tripInformation.vehicleMileageRec) - parseFloat(tripInformation.vehicleMileageRef)
          yield put(setVehicleMileageLoaded(loaded.toFixed(2)))
        }
      }
    } catch (e) {
      yield put(throwPcrException(`setCalculateVehicleMileageLoaded() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* setCalculateVehicleMileageLoadedSaga() {
  yield takeLatest(
    [TripInformationConstants.CALCULATE_VEHICLE_MILEAGE_LOADED],
    performWithMutexHOG,
    setCalculateVehicleMileageLoaded
  )
}
